import { render, staticRenderFns } from "./Packet.vue?vue&type=template&id=ae51b9d0"
import script from "./Packet.vue?vue&type=script&lang=js"
export * from "./Packet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports